<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api'

const router = useRouter();

const loading = ref(false);
const pendingContracts = ref([]);
const pendingDialogVisible = ref(false);

const steps = [
  {
    icon: "Shop",
    text: "添加店铺",
  },
  {
    icon: "DocumentAdd",
    text: "发起合同",
  },
  {
    icon: "Clock",
    text: "等待审批",
  },
];

const cards = [
  {
    icon: "Shop",
    title: "添加店铺",
    description: "前往查看添加的店铺列表或添加要合作的店铺",
    buttonText: "店铺列表",
    path: "/merchant/shop",
  },
  {
    icon: "DocumentAdd",
    title: "商务合同",
    description: "前往查看发起的合同列表或发起合同",
    buttonText: "合同列表",
    path: "/main_business/contract",
  },
  {
    icon: "Clock",
    title: "等待审批",
    description: "查看正在审批中的合同和补充协议",
    buttonText: "立即查看",
    path: "/main_business/contract",
  },
];

const getPendingContracts = async () => {
  loading.value = true;
  try {
    const res = await api.post('/api/main_business/get_pending_contracts');
    if (res.status === 1) {
      pendingContracts.value = res.data.list || [];
      if (res.data.list && res.data.list.length > 0) {
        pendingDialogVisible.value = true;
      }
    }
  } catch (error) {
    console.error('获取待办理合同失败:', error);
  } finally {
    loading.value = false;
  }
};

const goToContractDetail = (contract) => {
  if (contract.contract_type === 3) {
    router.push('/main_business/supplement_detail/' + contract.id);
  } else {
    router.push('/main_business/contract_detail/' + contract.id);
  }
};

onMounted(() => {
  getPendingContracts();
});
</script>

<template>
  <div>
    <page-main>
      <el-scrollbar style="height: calc(100vh - 250px)">
        <div class="page-container">
          <!-- 顶部流程图 -->

          <!-- 入驻成功提示 -->
          <el-alert
            title="入驻成功！"
            type="success"
            description="您已经成功入驻，现在可以进行添加店铺，等待商务发起合同。"
            show-icon
            :closable="false"
            style="margin-bottom: 20px"
          />

          <!-- 卡片列表 -->
          <div class="cards-container">
            <div v-for="(card, index) in cards" :key="index" class="card-item" @click="router.push(card.path)">
              <div class="card-icon">
                <component :is="card.icon" />
              </div>
              <div class="card-content">
                <div class="card-title">{{ card.title }}</div>
                <div class="card-description">{{ card.description }}</div>
                <div class="card-button">
                  <el-button type="primary">{{ card.buttonText }}</el-button>
                </div>
              </div>
            </div>
      </div>

        </div>
      </el-scrollbar>
    </page-main>

    <el-dialog
      v-model="pendingDialogVisible"
      title="待办理合同"
      width="700px"
      :close-on-click-modal="false"
      class="pending-dialog"
    >
      <div class="pending-list">
        <div v-for="(contract, index) in pendingContracts" :key="index" class="pending-item" @click="goToContractDetail(contract)">
          <div class="pending-header">
           
            <div class="pending-no">{{ contract.contract_no || '-' }}</div>
            <div class="pending-status">
              <el-tag v-if="contract.status === 5" type="warning" size="small" effect="plain">待办理</el-tag>
              <el-tag v-if="contract.status === 7" type="primary" size="small" effect="plain">处理中</el-tag>
            </div>
          </div>
          <div class="pending-body">
            <div class="info-row">
              <span class="label">合同类型</span>
              <span class="value">{{ contract.contract_type === 3 ? '补充协议' : '主营合同' }}</span>
            </div>
            <div v-if="contract.create_time" class="info-row">
              <span class="label">创建时间</span>
              <span class="value">{{ contract.create_time }}</span>
            </div>
          </div>
          <div class="pending-footer">
            <el-icon class="arrow-icon"><ArrowRight /></el-icon>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.page-container {
  padding: 20px;
}

.steps-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
}

.step-item {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  justify-content: center;
}

.step-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.step-icon :deep(svg) {
  width: 24px;
  height: 24px;
  color: white;
}

.step-text {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.step-line {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.card-item {
  background: white;
  border-radius: 8px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.card-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon :deep(svg) {
  width: 30px;
  height: 30px;
  color: white;
}

.card-content {
  flex: 1;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.card-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 16px;
}

.card-button {
  margin-top: auto;
}

.pending-section {
  margin-top: 30px;
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
}

.section-title svg {
  width: 20px;
  height: 20px;
  color: #f59a0b;
}

.pending-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 510px;
  overflow-y: auto;
  overflow-x: hidden;
}

.pending-item {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  gap: 16px;
}

.pending-item:hover {
  background: #f8f9fa;
  border-color: #409eff;
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.pending-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.contract-type-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contract-type-icon.supplement {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.contract-type-icon.main {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contract-type-icon :deep(svg) {
  width: 20px;
  height: 20px;
  color: white;
}

.pending-no {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.pending-status {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.pending-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.info-row .label {
  color: #909399;
  font-weight: 500;
  min-width: 70px;
}

.info-row .value {
  color: #64748b;
}

.pending-footer {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.arrow-icon {
  color: #409eff;
  font-size: 18px;
  transition: transform 0.3s ease;
}

.pending-item:hover .arrow-icon {
  transform: translateX(4px);
}

:deep(.pending-dialog .el-dialog__body) {
  padding: 16px 24px;
}
</style>
